import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_mama-agency-hub/artifacts/vil5cmq0_logo-mama.png";

// ---------------------------------------------------------------------------
// 401 interceptor — auto-refresh once, then redirect to /login?expired=1
// ---------------------------------------------------------------------------
const PUBLIC_PATHS = ["/auth/login", "/auth/refresh", "/auth/me",
                      "/agencies/public", "/categories", "/tickets/queue",
                      "/display-messages", "/settings",
                      "/queue/", "/display/"];

const isPublic = (cfg) => {
  const url = cfg?.url || "";
  // public ticket-status page must NOT auto-refresh
  if (url.includes("/status-public")) return true;
  // public kiosk cancel
  if (url.includes("/cancel-public")) return true;
  return PUBLIC_PATHS.some((p) => url.includes(p));
};

let refreshPromise = null;

api.interceptors.response.use(
  (resp) => resp,
  async (error) => {
    const cfg = error?.config;
    const status = error?.response?.status;
    if (!cfg || status !== 401 || cfg._retried || isPublic(cfg)) {
      return Promise.reject(error);
    }
    cfg._retried = true;
    try {
      refreshPromise = refreshPromise || api.post("/auth/refresh");
      await refreshPromise;
      refreshPromise = null;
      return api(cfg); // replay original request
    } catch (refreshErr) {
      refreshPromise = null;
      // Hard expiry — let the app react
      if (typeof window !== "undefined"
          && !window.location.pathname.startsWith("/login")
          && !window.location.pathname.startsWith("/display")
          && !window.location.pathname.startsWith("/kiosk")) {
        window.location.assign("/login?expired=1");
      }
      return Promise.reject(refreshErr);
    }
  },
);

export function formatApiError(detail) {
  if (detail == null) return "Une erreur est survenue. Veuillez réessayer.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export function getWsUrl(agencyId) {
  const url = new URL(BACKEND_URL);
  const proto = url.protocol === "https:" ? "wss:" : "ws:";
  return `${proto}//${url.host}/api/ws/${agencyId}`;
}
